import { TrackingHandler } from '../tracking/TrackingHandler';
const preselectLocationSelects = (location) => {
    const locationSelects = document.querySelectorAll('select[name="location"]');
    locationSelects.forEach((locationSelect) => preselectOption(locationSelect, location));
};
const preselectProductSelects = (product) => {
    const productSelects = document.querySelectorAll('select[name="product_c"]');
    productSelects.forEach((productSelect) => preselectOption(productSelect, product));
};
const preselectOption = (select, value) => {
    const matchingOptions = select.querySelectorAll('option[value="' + value + '"]');
    if (matchingOptions.length === 0) {
        return;
    }
    select.querySelectorAll('option').forEach((option) => option.removeAttribute('selected'));
    matchingOptions.forEach((option) => (option.selected = true));
};
export const initPreselect = () => {
    const init = () => {
        const trackingHandler = TrackingHandler.getInstance();
        const location = trackingHandler.pageLocation;
        const product = trackingHandler.pageProduct;
        if (location) {
            preselectLocationSelects(location);
        }
        if (product) {
            preselectProductSelects(product);
        }
    };
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
};
